/**
 * Analytics API
 */

import { apiClient } from "./apiClient";

export const analyticsAPI = {
  getDashboard: (organizationId) =>
    apiClient.get(`/analytics/org/${organizationId}/`),
  getSummary: () => apiClient.get("/analytics/summary/"),
  getRecentActivities: (organizationId) =>
    apiClient.get(`/analytics/org/${organizationId}/activities/`),
  getAnalystStats: () => apiClient.get("/analytics/analyst/stats/"),
};
